import React, { useContext } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';
import CookieConsent from 'react-cookie-consent';
import { Trans, withTranslation } from 'react-i18next';

import './Cookie.module.css';
import CountryContext from '../../../../common/context/country';

const CookieConsentBar = ({ t }) => {
  const country = useContext(CountryContext);
  return (
    <section
      styleName="cookie-consent-body"
      aria-label={t('Cookie consent body text')}
    >
      <div styleName="cookie-container">
        <CookieConsent
          location="none"
          buttonText="&times;"
          cookieName="formlabsCookieConsent"
          contentClasses="cookie-copy"
          style={{
            color: '#000',
            backgroundColor: '#f3f3f3',
            boxShadow: '0 2px 23px 0 rgba(0, 0, 0, 0.6)',
            position: 'static',
            width: 'auto',
            fontSize: '15px'
          }}
          buttonStyle={{
            backgroundColor: 'transparent',
            color: '#000',
            fontSize: '25px',
            lineHeight: '.8',
            fontWeight: '300',
            alignSelf: 'center'
          }}
          expires={150}
        >
          <style
            dangerouslySetInnerHTML={{
              __html: `#drift-widget {bottom:70px !important}`
            }}
          />
          <Trans>
            This website uses cookies to ensure you get the best experience.{' '}
            <Link to={`${country.path}privacy-policy/`}>More Info</Link>
          </Trans>
        </CookieConsent>
      </div>
    </section>
  );
};
export default DisplayComponent(withTranslation()(CookieConsentBar));
